<template>
  <public header="add-code">
  <v-app id="app" class="public mt-10">
    <v-main>
      <v-container>
        <v-row align="center" justify="center">
          <v-col cols="12" md="8" class="mb-16">
            <v-card class="elevation-0 pa-2">
              <v-card-text class="text--primary">
                <form ref="form" @submit="submit" id="register">
                <v-row>
                  <v-col cols="12" md="12" class="pb-0 pt-0">
                    <v-text-field outlined
                                  label="โค้ดลงทะเบียนเข้าสู่บริษัท"
                                  required
                                  v-model="registerToken"
                                  :disabled="registerCompanyLoading"
                    ></v-text-field>
                  </v-col>
                </v-row>
                </form>
              </v-card-text>
              <save-alert :status="registerStatus && (registerStatus === 'success' ? 'success': 'error')"
                          :error-text="alertText[registerStatus]"
                          success-text="เพิ่มบริษัทสำเร็จ" v-if="registerStatus"></save-alert>
              <v-card-actions style="width: 50%; margin: 0 auto;">
                <v-btn class="mr-4" type="submit" color="primary" block form="register" :disabled="registerCompanyLoading">
                  <v-progress-circular
                    indeterminate
                    color="green"
                    v-if="registerCompanyLoading"
                    left
                  ></v-progress-circular>
                  ดำเนินการต่อ
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
      <footer-web></footer-web>
    </v-main>
  </v-app>
  </public>
</template>

<script>
import FooterWeb from '@/components/public/footer'
import firebase from "firebase/app";
import "firebase/auth"
import fc from "@/firebaseConfig";
import SaveAlert from '../../components/admin/save-alert'
import router from "@/router";
import Public from '@/components/public/public-main-template'

const axios = require("axios");

export default {
  components:{
    FooterWeb,
    SaveAlert,
    Public
  },
  data(){
    return {
      registerToken: "",
      registerCompanyLoading: false,
      registerStatus: null,
      alertText:{
        "error": "เพิ่มบริษัทใหม่ไม่สำเร็จ กรุณาลองใหม่อีกครั้ง",
        "User Auth Error": "เพิ่มบริษัทใหม่ไม่สำเร็จ กรุณาเข้าสู่ระบบใหม่อีกครั้ง",
        "Register Code Invalid": "เพิ่มบริษัทใหม่ไม่สำเร็จ กรุณาตรวจสอบโค้ดและลองใหม่อีกครั้ง",
        "Register User Error": "เพิ่มบริษัทใหม่ไม่สำเร็จ กรุณาตรวจสอบและลองใหม่อีกครั้ง",
      },
    }
  },
  methods:{
    submit: async function (e) {
      e.preventDefault();
      this.registerCompanyLoading = true
      this.registerStatus = null
      // get user token
      let token = await firebase.auth().currentUser.getIdToken(/* forceRefresh */ false)
        .then(function (idToken) {
          return idToken
        });
      const headers = {
        'Content-Type': 'application/json',
        'Authorization': 'JWT ' + token
      }

      await axios.post(fc.cloudFunctionUrl + "onCheckTokenRegister", {registerToken: this.registerToken}, {headers})
        .then((response) => {
          if (response.status === 200) {
            this.registerStatus = "success"
            router.push(response.data? `${response.data}/dashboard`: "/companies-list")
          }
        }, (error) => {
            this.registerStatus = error.response.data ? error.response.data : "error"
        });
      this.registerCompanyLoading = false
    }
  }
}
</script>

<style lang="scss">
* {
  font-family: "Noto Sans Thai", "Noto Sans", sans-serif;
}
.add-company-logo {
  width: 100px;
  display: block;
  margin: 20px auto;
}
.alert-detail{
  padding: 16px;
}
</style>
